import React, { useState } from 'react';
import InformationCircleIcon from '@heroicons/react/outline/InformationCircleIcon.js';
import { T, useStaticIntl } from '@tribeplatform/react-components/i18n';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { Tabs } from '@tribeplatform/react-ui-kit/Tabs';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { leaderboardTabsFactory } from './constants.js';
import { LeaderboardTab } from './LeaderboardTab.js';
export const LeaderboardBlock = ({ heading, spaceId, membersCount, excludeStaff, defaultTab, showScore, }) => {
    const leaderboardTabs = useStaticIntl(leaderboardTabsFactory);
    let defaultTabIndex = leaderboardTabs.findIndex(tab => tab.value === defaultTab);
    if (defaultTabIndex === -1) {
        defaultTabIndex = 0;
    }
    const [activeTab, setActiveTab] = useState(defaultTabIndex);
    return (React.createElement("div", { className: "block-leaderboard" },
        React.createElement(Card, null,
            React.createElement(Card.Header, { title: heading, action: React.createElement(Tooltip, { placement: "left" },
                    React.createElement(Tooltip.Trigger, null,
                        React.createElement(InformationCircleIcon, { className: "w-5 h-5 text-content-subdued" })),
                    React.createElement(Tooltip.Panel, null,
                        React.createElement(T, { id: "Blocks.Leaderboard.ScoreCalculationDescription", defaultMessage: "Scores are calculated based on the number of posts, replies, and reactions" }))), size: "sm" }),
            React.createElement(Card.Content, null,
                React.createElement(Tabs.Group, { onChange: setActiveTab, defaultIndex: activeTab },
                    React.createElement(Tabs.List, { size: "sm", variant: "pills", fullWidth: true, className: "bg-surface-subdued rounded-md p-1" }, leaderboardTabs.map(tab => (React.createElement(Tabs.Tab, { className: "whitespace-nowrap", name: tab.value, key: tab.value }, tab.text)))),
                    React.createElement(Tabs.Panels, null, leaderboardTabs.map(tab => (React.createElement(Tabs.Panel, { key: tab.value },
                        React.createElement(LeaderboardTab, { membersCount: membersCount, spaceId: spaceId, timeFrame: tab.value, excludeStaff: excludeStaff, showScore: showScore }))))))))));
};
//# sourceMappingURL=Block.js.map